import React, { useEffect, useState } from "react";
import { useStaffMinutesStore } from "../../../config/stores";
import { searchTable } from "../../../config/constants";
import TableTitle from "../../../components/common/TableTitle";
import AntdTable from "../../../components/common/AntdTable";
import TableButtonActions from "../../../components/common/TableButtonActions";
import moment from "moment";
import { isEmpty } from "lodash";
import StaffMinutesForm from "./StaffMinutesForm";
import StaffMinutesDetails from "./StaffMinutesDetails";
import RecordStatus from "../../../components/common/RecordStatus";

const StaffMinutes = () => {
  const [filterTable, setFilterTableNull] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const staffMinutesStore = useStaffMinutesStore();
  const {
    staffMinutes,
    setCreatingStaffMinute,
    showStaffMinuteDetails,
    setShowStaffMinuteDetails,
  } = staffMinutesStore;

  const search = (value) => {
    const filterTable = searchTable(staffMinutes, value);
    setFilterTableNull(filterTable);
  };

  const confirmDelete = () => {
    staffMinutesStore.deleteStaffMinute(deleteId);
  };

  const deleteRecord = (id) => setDeleteId(id);

  const updateRecord = (record) => {
    setCreatingStaffMinute(true, false, record);
  };
  const viewDetails = (record) => {
    setShowStaffMinuteDetails(true, record);
  };

  const openAddModal = () => {
    setCreatingStaffMinute(true, true, null);
  };

  const refreshTable = () => {
    staffMinutesStore.getStaffMinutes();
  };

  useEffect(() => {
    if (isEmpty(staffMinutes)) {
      staffMinutesStore.getStaffMinutes();
    }
  }, []);

  return (
    <div className="container-fluid p-2">
      <h5 className="fw-bold">STAFF MINUTES</h5>

      {showStaffMinuteDetails ? (
        <StaffMinutesDetails />
      ) : (
        <>
          <AntdTable
            loading={staffMinutesStore.gettingStaffMinutes}
            title={() => (
              <TableTitle
                setFilterTableNull={setFilterTableNull}
                openAddModal={openAddModal}
                refreshTable={refreshTable}
                search={search}
                exportRecords={null}
              />
            )}
            pageSize={20}
            data={filterTable === null ? staffMinutes || [] : filterTable}
            columns={[
              {
                title: "Date",
                dataIndex: "date",
                key: "date",
                render: (text) => moment(text).format("DD/MM/YYYY"),
              },
              {
                title: "Type",
                dataIndex: "type",
                key: "type",
              },
              {
                title: "Venue",
                dataIndex: "venue",
                key: "venue",
              },
              {
                title: "Status",
                dataIndex: "status",
                key: "status",
                render: (status) => <RecordStatus status={status} />,
              },
              {
                title: "Created By",
                dataIndex: ["created_by", "first_name"],
                key: "created_by",
                render: (_, record) =>
                  `${record?.created_by?.first_name || ""} ${
                    record?.created_by?.other_names || ""
                  }`,
              },
              {
                title: "Actions",
                key: "actions",
                render: (record) => (
                  <TableButtonActions
                    record={record}
                    confirmDelete={confirmDelete}
                    deleteLoading={staffMinutesStore.deletingStaffMinute}
                    viewDetails={() => viewDetails(record)}
                    updateRecord={() => updateRecord(record)}
                    deleteId={deleteId}
                    deleteRecord={deleteRecord}
                  />
                ),
              },
            ]}
          />
          <StaffMinutesForm />
        </>
      )}
    </div>
  );
};

export default StaffMinutes;
